(function () {
  if (window.ResponsiveMediaBanner) {
    window.ResponsiveMediaBanner.init(document);
    return;
  }

  var desktopQuery = window.matchMedia('(min-width: 768px) and (hover: hover) and (pointer: fine)');
  var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function shouldLoadDesktopVideo() {
    return desktopQuery.matches && !reducedMotionQuery.matches;
  }

  function setLoadedState(video, isLoaded) {
    var section = video.closest('[data-responsive-media-banner]');
    var inner = video.closest('.responsive-media-banner__inner') || (section ? section.querySelector('.responsive-media-banner__inner') : null);

    if (inner) {
      inner.setAttribute('data-responsive-media-banner-video-loaded', isLoaded ? 'true' : 'false');
    }
  }

  function loadVideo(video) {
    var src = video.getAttribute('data-src');

    if (!src || video.getAttribute('data-responsive-media-banner-loaded') === 'true' || !shouldLoadDesktopVideo()) {
      return;
    }

    var source = document.createElement('source');
    source.src = src;
    source.type = video.getAttribute('data-type') || 'video/mp4';

    video.appendChild(source);
    video.setAttribute('data-responsive-media-banner-loaded', 'true');

    video.addEventListener('loadeddata', function () {
      setLoadedState(video, true);
    }, { once: true });

    video.load();

    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {
        setLoadedState(video, false);
      });
    }
  }

  function unloadVideo(video) {
    if (video.getAttribute('data-responsive-media-banner-loaded') !== 'true') {
      return;
    }

    video.pause();
    video.removeAttribute('src');

    while (video.firstChild) {
      video.removeChild(video.firstChild);
    }

    video.load();
    video.removeAttribute('data-responsive-media-banner-loaded');
    setLoadedState(video, false);
  }

  function observeVideo(video) {
    if (!shouldLoadDesktopVideo()) {
      return;
    }

    if (!('IntersectionObserver' in window)) {
      loadVideo(video);
      return;
    }

    if (video.getAttribute('data-responsive-media-banner-observing') === 'true') {
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && shouldLoadDesktopVideo()) {
          loadVideo(video);
          observer.disconnect();
          video.removeAttribute('data-responsive-media-banner-observing');
        }
      });
    }, {
      rootMargin: '300px 0px'
    });

    observer.observe(video);
    video.setAttribute('data-responsive-media-banner-observing', 'true');
  }

  function init(scope) {
    var root = scope || document;
    var videos = root.querySelectorAll('[data-responsive-media-banner] [data-responsive-media-banner-video]');

    videos.forEach(function (video) {
      if (shouldLoadDesktopVideo()) {
        observeVideo(video);
      } else {
        unloadVideo(video);
      }
    });
  }

  function bindQuery(query) {
    var sync = function () {
      init(document);
    };

    if (typeof query.addEventListener === 'function') {
      query.addEventListener('change', sync);
    } else if (typeof query.addListener === 'function') {
      query.addListener(sync);
    }
  }

  window.ResponsiveMediaBanner = {
    init: init
  };

  // Video source assignment stays in JS so coarse-pointer mobile browsers
  // receive image-only media markup and never get a downloadable desktop source.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  bindQuery(desktopQuery);
  bindQuery(reducedMotionQuery);
})();
